import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="border-y border-background-200 bg-background-100">
      <div className="container-x py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="text-xs font-medium tracking-[0.2em] text-secondary-600">FAQ / 常见问题</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              读之前你可能想问的
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              如果这里没有你想问的，可以到
              <Link to="/about#contact" className="mx-1 font-medium text-primary-600 hover:text-primary-700">
                关于我们
              </Link>
              页面投递线索或直接联系我们。
            </p>
          </div>

          <div className="lg:col-span-8">
            <dl className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((faq, i) => {
                const open = openIndex === i;
                return (
                  <div key={faq.question} className="py-1">
                    <dt>
                      <button
                        type="button"
                        aria-expanded={open}
                        onClick={() => setOpenIndex(open ? null : i)}
                        className="flex w-full cursor-pointer items-start justify-between gap-4 py-5 text-left"
                      >
                        <span className="font-heading text-base font-bold leading-7 text-foreground-950">
                          {faq.question}
                        </span>
                        <span
                          className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md transition-colors ${
                            open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                        </span>
                      </button>
                    </dt>
                    {open && (
                      <dd className="pb-5 pr-11 text-sm leading-7 text-foreground-600">{faq.answer}</dd>
                    )}
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}